import React, {Component} from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
//import fetch from 'isomorphic-fetch';
//import * as actions from '../../actions/venue_list';
import fetchVenues from '../../actions/venue_list'
import Venue from './venue'

export class VenueList extends Component {
  constructor(props) {
    super(props)

    this.state = {
      venues: [],
    }
  }

  componentDidMount() {
    //console.log('component mounting with fetchVenues')
    // so we can get tests to run without fetching data and pass in as props...
    // not ideal but might be good enough
    //if(!this.props.venueList.venues) {
    this.props.fetchVenues()
    //}
  }

  render() {
    if (this.props.loading) {
      return (
        <div className="alert alert-success" role="alert">
          <strong>loading...</strong>
        </div>
      )
    } else {
      return (
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>#</th>
              <th>Venue Name</th>
              <th>Venue Postcode</th>
            </tr>
          </thead>
          <tbody>
            {this.props.venueList.map((venue, index) => {
              return (
                <Venue
                  key={index}
                  name={venue.name}
                  postcode={venue.postcode}
                  id={venue._id}
                  item={index + 1}
                />
              )
            })}
          </tbody>
        </table>
      )
    }

    //console.log('props.venues: ' + JSON.stringify(this.props.venueList))
    // if (this.props.venueList.venues) {
    //   // console.log('Ok I reckon I got something for you, have a look :)')
    //   // console.log('vl: ' + JSON.stringify(this.props.venueList.venues))
    //   // console.log('venueList length: ' + this.props.venueList.venues.length)
    //
    //   //console.log('venueList lengthy: ' + this.props.venueList.venues.length)
    //   return (
    //     <div className="venue-list">
    //       { this.props.venueList.venues.map((venue, index) => {
    //         return (
    //           // <h1>Huh</h1>
    //           <Venue
    //             key={ index }
    //             name={ venue.name } />
    //         )
    //       })
    //     }
    //     </div>
    //   )
    // }
  }
  // _constructVenueList() {
  //   console.log('dispaly venue..')
  //
  //   return this.props.venues.map((venue, index) => {
  //     return (
  //       <Venue
  //         key={ index }
  //         name={ venue.name } />
  //     )
  //   })
  // }
}

// function mapStateToProps({ venueList }) {
//   return { venueList }
// }

function mapStateToProps(state) {
  return {
    venueList: state.venueList.venues,
    loading: state.venueList.loading,
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchVenues: fetchVenues,
    },
    dispatch,
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(VenueList)



/** WEBPACK FOOTER **
 ** ./src/components/venues/list.js
 **/